// Copyright (c) 2020 WiseTime. All rights reserved.

import React, { memo } from "react"
import styled from "styled-components/macro"
import TimeRowIconDesc from "../shared/TimeRowIconDesc"
import RowDuration from "../shared/RowDuration"
import ActionTimeRowRemoveButton from "./ActionTimeRowRemoveButton"
import { SharedTimeRow } from "features/shared/styles"
import * as TimelineSlice from "../slices/timeline"
import { useDispatch } from "react-redux"
import * as TrashedTimeRowSlice from "../trash/slice"
import { ROW_COPY_TO_CLIPBOARD_CLASSNAME } from "../../shared/classNames"

const Row = styled(SharedTimeRow)`
  border-width: 0 0 1px 0;
  border-color: ${({ theme }): string => theme.colors.mercury};
  padding-left: 12px;
  padding-right: 3px;

  ${`.${ROW_COPY_TO_CLIPBOARD_CLASSNAME}`} {
    display: none;
  }
  
  &:last-child {
    border-bottom-width: 0;
  }
  @media (hover: hover) and (pointer: fine) {
      &:hover {
          ${`.${ROW_COPY_TO_CLIPBOARD_CLASSNAME}`} {
              display: inline-flex;
          }
      }
  }
`

type Props = {
  timeRowId: string,
  activity: string,
  description: string,
  iconUrl?: string,
  duration?: number,
  isTrashed: boolean,
}

const ActionTimeRow = ({
  timeRowId,
  activity,
  description,
  iconUrl = "",
  duration = 0,
  isTrashed,
}: Props): React.ReactElement<Props> => {
  const dispatch = useDispatch()

  const onRemove = (): void => {
    if (isTrashed) {
      dispatch(TrashedTimeRowSlice.removeActiveTrashedTimeRowIds([timeRowId]))
    } else {
      dispatch(TimelineSlice.removeActiveTimeRowIds({ timeRowIds: [timeRowId]}))
    }
  }
  return (
    <Row>
      <TimeRowIconDesc
        activity={activity}
        description={description}
        iconUrl={iconUrl}
      />
      <RowDuration duration={duration} />
      <ActionTimeRowRemoveButton onClick={onRemove} />
    </Row>
  )
}

export default memo(ActionTimeRow)
